<template>
  <section class="page">
    <ListPlaces 
      :places="getPlaces || places" 
      :class="{timeline_hidden: !getList}"
    />
    <div class="page-content">
    <transition name="slide">
    <Place 
      v-if="!getModePlaces" 
      :place="getActive" 
      @deletePlace="deleting = true"
      @setComplain="setComplain"
    />
    </transition>
    <Map />
    </div>
    <ModalPhotos />
    <Complain 
      v-if="complain"
      :settings="complain"
      @click.native="complain = null" 
    />
    <div class="confirm" v-if="deleting">
      <div class="confirm-container">
      <h5>Вы действительно хотите удалить место?</h5>
      <div class="confirm-buttons">
          <div class="button" @click="deletePlace()">Да</div>
          <div class="button" @click="deleting = false">Нет</div>
      </div>
      </div>
    </div>
  </section>
</template>

<script>
import ListPlaces from './components/ListPlaces'
import Place from './components/Place'
export default {
  name: 'places',
  components: {
    ListPlaces,
    ModalPhotos: () => import('@/components/Modals/ModalPhoto'),
    Map: () => import('@/components/Map/MapPlaces'),
    Place,
    Complain: () => import('@/components/Lenta/Complain.vue')
  },
  data() {
    return {
      places: [],
      deleting: false,
      complain: null
    }
  },
  computed: {
    getPlaces () {
      return this.$store.getters.getPlaces
    },
    getList() {
      return this.$store.getters.getListPlaces;
    },
    getModePlaces () {
      return this.$store.getters.getModePlaces
    },
    getPage () {
      return this.$store.getters.getPlacesPage
    },
    getActive () {
      return this.$store.getters.getActivePlace
    },
    getFilters () {
      return this.$store.getters.getFilters
    },
    getActiveSports () {
      return this.$store.getters.getActiveSports
    },
    getTypePlaces() {
      return this.$store.getters.getTypePlaces;
    },
    getUser () {
      return this.$store.getters.getAuthUser
    }
  },
  watch: {
    getActive (event) {
      if (event && event.title) {
        document.title = 'WildWood — ' + event.title
        document.querySelector('meta[name="title"]').setAttribute("content", event.title); 
        document.querySelector('meta[property="og:title"]').setAttribute("content", event.title);
        document.querySelector('meta[property="og:image"]').setAttribute("content", event.cover);
        let description = event.content.find(block => block.type === 'paragraph');
        if (description) {
          document.querySelector('meta[property="og:description"]').setAttribute("content", description.value)
        } else {
          document.querySelector('meta[name="description"]').setAttribute("content", description.value); 
        }
      }
    },
    getFilters () {
      // clearInterval(this.startLoadingData())
      this.loadData()
    },
    getActiveSports () {
      // clearInterval(this.startLoadingData())
      this.loadData({loading: true})
    },
    getTypePlaces() {
      // clearInterval(this.startLoadingData())
      this.loadData({loading: true});
    },
    $route(to) {
      to.params.hash ? this.fetchPlace() : this.$store.dispatch('changeModePlaces', true)
    }
  },
  methods: {
    async loadData(options) {
      let params = {
        page: this.getPage, 
        filters: this.getFilters, 
        sports: this.getActiveSports,
        type: this.getTypePlaces,
        author: this.getUser
      };
      options && options.loading
        ? this.$store.dispatch('setLoader', { element: 'timeline', val: true })
        : '';
      this.places = await this.$store.dispatch('getPlaces', params);
      options && options.loading
        ? this.$store.dispatch('setLoader', { element: 'timeline', val: false })
        : '';
    },
    fetchPlace() {
      let hash = this.$route.params.hash;
      
      if (hash){
        if (hash.indexOf('&') !== -1) {
          let clear_hash = hash.split('&')[1];
          let id = hash.split('&')[0];
          this.$store.dispatch('fetchPlace', { hash: clear_hash, id: id });
        } else {
          this.$store.dispatch('fetchPlace', {hash})
        }
        this.$store.dispatch('changeModePlaces', false);
      } else {
        this.$store.dispatch('changeModePlaces', true);
      }
    },
    setComplain(data) {
      this.complain = data
    },
    startLoadingData() {
      return setInterval(async () => {
        this.$route.name == 'places' || this.$route.name == 'place' ? this.loadData() : '';
      }, 2 * 60 * 1000);
    },
    async deletePlace() {
      await this.$store.dispatch('deletePlace', {place: this.getActive})
      .then(res => {
        if (res) {
          this.deleting = false
          this.$store.dispatch('addNotification', {message: `Ваше место удалено`})
          this.$router.push({name: 'places'})
        } else {
          this.$store.dispatch('addError', {message: `Что-то пошло не так...`})
        }
      })
    },
    getLocation() {
      var options = {
        enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
      };
      let success = async pos => {
        let crd = pos.coords;
          let location = {
              latitude: crd.latitude,
              longitude: crd.longitude
          };
          this.$store.dispatch('setCenter', [crd.latitude, crd.longitude])
          let state = await this.$axios.post('/api/zones/by_coords', {coords: location})
          // this.$store.dispatch('setLocationState', {name: state.data.state, state_code: state.data.state_code});
          this.$store.dispatch('setMapCity', {name: state.data.state, state_code: state.data.state_code})
          this.$store.dispatch('setLocation', location);
      }

      let error = () => {
          this.$store.dispatch('addNotification', {message: "Не получилось определить ваше местоположение"})
          this.$store.dispatch('setLocation', {error: true});
          this.getLocationProfile()
      }

      navigator.geolocation.getCurrentPosition(success, error, options);
      
    },
    getLocationProfile() {
      let user_string = localStorage.getItem('user');
      let user = JSON.parse(user_string);
      let findedCountry = this.getFilters.find(item => item.group === 'city' && item.filter.name);
      findedCountry ? this.getFilters.splice(this.getFilters.indexOf(findedCountry), 1) : '';
      if (user && user.state_code && user.state) {
          this.getFilters.push({filter: {name: user.state, state_code: user.state_code}, group: 'city'})
          this.$store.dispatch('setMapCity', {name: user.state, state_code: user.state_code})
          this.$axios.post('/api/zones/by_code', {country: {Iso2: user.country_code}, region: {name: user.state, state_code: user.state_code}})
            .then( res => {
              this.$store.dispatch('setCenter', [res.data.center[1], res.data.center[0]]);
              this.$store.dispatch('setMapZoom', 7);
            })
      }
    }
  },
  mounted () {
    this.loadData({loading: true})
    // this.startLoadingData()
  },
  created () {
    this.fetchPlace()
    document.title = this.$route.meta.title;
    this.$store.getters.getLocation && this.$store.getters.getLocation.error 
    ? this.getLocationProfile() 
    : this.getLocation()
  }
}

</script>